import { useContext } from 'react';
import { EditLegalEntitiesDrawerContext } from './EditLegalEntitiesDrawerContext';

export const useEditLegalEntitiesDrawer = () => useContext(EditLegalEntitiesDrawerContext);
